export class Tips {
	static NAMES = {
		GOAL: "goal", 			// #1
		WILD: "wild", 			// #2
		ZOOM: "zoom"			// #3
	} ;

	static tipShown = name => localStorage.getItem('tipshown_' + name) === 'true' || false;
	static saveTip = name => window.setPersistentStorage('tipshown_' + name, 'true');
	static isShowing = false;

	static showTip = (name, y, wildRect = null) => {
		if(!Tips.isShowing && !Tips.tipShown(name)) {
			Tips.isShowing = true;
			const m = window.manager;
			let undimArea, arrowData, arrow

			switch (name) {
				case Tips.NAMES.GOAL : {
					undimArea = dim => dim.fillRoundedRect(
						0.25* m.config.width,
						0.085* m.config.height,
						0.5* m.config.width,
						0.1* m.config.height,
						0.05 * m.config.width
					)
					arrowData = null;
					break;
				}
				case Tips.NAMES.WILD : {
					undimArea = dim => dim.fillRoundedRect(wildRect.left, wildRect.top, wildRect.width, wildRect.height, 50)
					arrowData = {
						x: wildRect.centerX, 
						topY: wildRect.bottom - 30, 
						bottomY: wildRect.bottom + 10}
					break;
				}
				case Tips.NAMES.ZOOM : {
					undimArea = dim => dim.fillCircle(m.ui.zoomButtonTop.x, m.ui.zoomButtonTop.y, 75);
					arrowData = {
						x: m.ui.zoomButtonTop.x, 
						topY: m.ui.zoomButtonTop.y + 25,
						bottomY: m.ui.zoomButtonTop.y + 75}
					break;
				}
				default : {
					console.log('8596 ----- unknown tip')
				}
			}

			// add dim with hole
			const dim = m.scene.add.graphics().setDepth(5);
			const hole = m.scene.add.graphics().setVisible(false);
  			dim.setMask(hole.createGeometryMask().setInvertAlpha(true));
			dim.fillStyle(0x000000, 0.5).fillRect(0, 0, m.config.width, m.config.height);
			undimArea(hole.fillStyle(0x0000ff))

			const hit = m.scene.add.image(m.config.width/2, m.config.height/2, 'dimPanel')
				.setDisplaySize(m.config.width, m.config.height).setAlpha(0.001)
				.setDepth(42).setInteractive()
				.once('pointerdown', pointer => {
					// idk why it's needed, looks like smth about time to process...
					const arr = m.scene.input.hitTestPointer(pointer)
					console.log('8770 tip down arr =', arr, 'n =', arr.map(v => v.texture?.key))
				}) 

			if(arrowData) {
				arrow = m.scene.add.sprite(arrowData.x, arrowData.bottomY, 'common', 'arrow_gold.png')
				.setDepth(37).setScale(0.5*m.scaleFactor).setOrigin(0.5, 0);
				m.scene.tweens.add({targets: arrow,	y: arrowData.topY, 
					duration: 1000, repeat: -1, yoyo: true
				})
			}

			const boxTween = m.ui.createTutorialBox('tips_' + name, y);
			const panel = boxTween.targets[0]
			panel.setDepth(39)
			panel.first.setInteractive({useHandCursor: false})
			const box = boxTween.targets[0].getBounds()

			const btn = m.scene.add.image(box.right - 25 + m.config.width, box.top/* -m.config.height/2 */, 'btn_close')
				.setDepth(42).setAlpha(0).setInteractive({useHandCursor: true})

			const clear = pointer => {
				const arr = m.scene.input.hitTestPointer(pointer)
				console.log('8770 tip up arr =', arr, 'n =', arr.map(v => v.texture?.key))
				Tips.saveTip(name);
				[dim, arrow, ...boxTween.targets, btn, hit].forEach(v => { 
					if(v) v.setVisible(false);
					setTimeout(() => {
						if(v)	v.destroy(); 
					}, 100)
				})
				Tips.isShowing = false;
			}
			hit.once('pointerup', clear)
			btn.once('pointerup', clear)

			setTimeout(() => {btn.setAlpha(1)}, 300)
		}
	}

}